import OnboardingIntegrationGoogleCalendar
  from "../modules/onboarding/integrations/OnboardingIntegrationGoogleCalendar.vue";
import OnboardingIntegrationLaunchControl
  from "../modules/onboarding/integrations/OnboardingIntegrationLaunchControl.vue";
import OnboardingIntegrationCallRail from "../modules/onboarding/integrations/OnboardingIntegrationCallRail.vue";
import OnboardingIntegrationGmail from "../modules/onboarding/integrations/OnboardingIntegrationGmail.vue";
import OnboardingIntegrationCustomEmail from "../modules/onboarding/integrations/OnboardingIntegrationCustomEmail.vue";
import OnboardingIntegrationSmrtPhone from "../modules/onboarding/integrations/OnboardingIntegrationSmrtPhone.vue";
import {ENUMS} from "../services/enums";
import utils from "../services/utils";

function convertDaysToMinutes(days) {
  return days * 60 * 24;
}

const state = () => ({
  onboarding: {
    is_provisioned: false,
    is_complete: false,
    chosen_integrations: {
      smrtPhone: {
        included: false,
        completed: false,
      },
      callRail: {
        included: false,
        completed: false,
      },
      gmail: {
        included: false,
        completed: false,
      },
      customDomain: {
        included: false,
        completed: false,
      },
      launchControl: {
        included: false,
        completed: false,
      },
      googleCalendar: {
        included: false,
        completed: false,
      },
    }
  },
  hasWhiteGloveService: false,
  provisionData: {
    statuses: {
      Contacting: [
        {
          label: 'New',
          order: 1,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Contacting.value,
          include: true,
        },
      ],
      Active: [
        {
          label: 'Analysis Needed',
          order: 1,
          acceptable_time: convertDaysToMinutes(1),
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
        {
          label: 'Appointment Set',
          order: 2,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
        {
          label: 'Negotiating',
          order: 3,
          acceptable_time: convertDaysToMinutes(5),
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
        {
          label: 'Under Contract',
          order: 4,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
        {
          label: 'Lineup Rehab',
          order: 5,
          acceptable_time: convertDaysToMinutes(5),
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
        {
          label: 'Rehabbing',
          order: 6,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
        {
          label: 'For Sale',
          order: 7,
          acceptable_time: convertDaysToMinutes(30),
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
        {
          label: 'Under Contract Selling',
          order: 8,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Active.value,
          include: true,
        },
      ],
      FollowUp: [
        {
          label: 'High Priority Follow Up',
          order: 1,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.FollowUp.value,
          include: true,
        },
        {
          label: 'Low Priority Follow Up',
          order: 2,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.FollowUp.value,
          include: true,
        },
      ],
      Completed: [
        {
          label: 'Wholesaled',
          order: 1,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Completed.value,
          include: true,
        },
        {
          label: 'Sold',
          order: 2,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Completed.value,
          include: true,
        },
        {
          label: 'Rented',
          order: 3,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Completed.value,
          include: true,
        },
      ],
      Dead: [
        {
          label: 'No Longer Interested',
          order: 1,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Dead.value,
          include: true,
        },
        {
          label: 'Already Sold',
          order: 2,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Dead.value,
          include: true,
        },
        {
          label: 'Do Not Contact',
          order: 3,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.Dead.value,
          include: true,
        },
      ],
      NonLead: [
        {
          label: 'Spam',
          order: 1,
          acceptable_time: null,
          state: ENUMS.StatusStateEnum.NonLead.value,
          include: true,
        }
      ]
    },
    types: {
      Seller: [
        {
          type: ENUMS.ContactTypeEnum.Seller.value,
          label: 'Seller',
          include: true,
          isDefault: true,
        },
      ],
      Other: [
        {
          type: ENUMS.ContactTypeEnum.Other.value,
          label: 'Buyer',
          include: true,
        },
        {
          type: ENUMS.ContactTypeEnum.Other.value,
          label: 'Agent',
          include: true,
        },
      ],
    },
    campaigns: [],
    followUps: [],
    users: [],
  },
  integrationSteps: {
    smrtPhone: {
      id: 'smrtPhone',
      label: 'smrtPhone',
      component: OnboardingIntegrationSmrtPhone,
    },
    callRail: {
      id: 'callrail',
      label: 'CallRail',
      component: OnboardingIntegrationCallRail,
    },
    gmail: {
      id: 'gmail',
      label: 'Gmail',
      component: OnboardingIntegrationGmail,
    },
    customDomain: {
      id: 'customEmail',
      label: 'Custom Email',
      component: OnboardingIntegrationCustomEmail,
    },
    launchControl: {
      id: 'launchControl',
      label: 'Launch Control',
      component: OnboardingIntegrationLaunchControl,
    },
    googleCalendar: {
      id: 'calendar',
      label: 'Google Calendar',
      component: OnboardingIntegrationGoogleCalendar,
    },
  },
});

const getters = {
  steps(state) {
    let steps = [];
    const keys = Object.keys(state.integrationSteps);

    keys.forEach(key => {
      if (state.onboarding.chosen_integrations && state.onboarding.chosen_integrations[key].included) {
        steps.push(state.integrationSteps[key]);
      }
    });

    return steps;
  },
};

const mutations = {
  updateOnboarding(state, newOnboarding) {
    state.onboarding = newOnboarding;
  },
  updateChosenIntegrations(state, payload) {
    state.onboarding.chosen_integrations = payload;
  },
  updateStatus(state, newStatus) {
    const stateKey = utils.getEnumItem(newStatus.state, ENUMS.StatusStateEnum).key;
    const statuses = state.provisionData.statuses[stateKey];

    state.provisionData.statuses[stateKey] = statuses.filter(status => {
      if(status.label === newStatus.label) {
        return newStatus;
      }

      return status;
    })
  },
  addContactType(state, newContactType) {
    const typeKey = utils.getEnumItem(newContactType.type, ENUMS.ContactTypeEnum).key;
    state.provisionData.types[typeKey].push(newContactType);
  },
  updateContactType(state, updatedContactType) {
    // Setup booleans
    const isSellerType = updatedContactType.type ===ENUMS.ContactTypeEnum.Seller.value;
    const resetDefaults = isSellerType && updatedContactType.isDefault;
    const newDefault = isSellerType && !updatedContactType.include && updatedContactType.isDefault;

    // Get the right type of types
    const typeKey = utils.getEnumItem(updatedContactType.type, ENUMS.ContactTypeEnum).key;
    const types = state.provisionData.types[typeKey];

    // remap the updatedContactType into the types
    const updatedTypes = types.map(type => {
      if(type.label === updatedContactType.label) {

        if(newDefault) updatedContactType.isDefault = false;

        return updatedContactType;
      }

      // if updatedContactType is now default then all existing types should not be default
      if(resetDefaults) type.isDefault = false;

      return type;
    })

    // Set the first still included type to the default
    if(newDefault) updatedTypes.filter(type => type.include)[0].isDefault = true;

    state.provisionData.types[typeKey] = updatedTypes;
  },
  addCampaign(state, newCampaign) {
    state.provisionData.campaigns.push(newCampaign)
  },
  deleteCampaign(state, oldCampaign) {
    state.provisionData.campaigns = state.provisionData.campaigns.filter(campaign => {
      if(campaign.label !== oldCampaign.label) {
        return campaign;
      }
    })
  },
  addFollowUp(state, newFollowUp) {
    state.provisionData.followUps.push(newFollowUp)
  },
  deleteFollowUp(state, oldFollowUp) {
    state.provisionData.followUps = state.provisionData.followUps.filter(followUp => {
      if(followUp.label !== oldFollowUp.label) {
        return followUp;
      }
    })
  },
  addUser(state, newUser) {
    state.provisionData.users.push(newUser)
  },
  deleteUser(state, oldUser) {
    state.provisionData.users = state.provisionData.users.filter(user => {
      if(user.email_address !== oldUser.email_address) {
        return user;
      }
    })
  },
  setWhiteGloveService(state) {
    state.hasWhiteGloveService = true;
  },
};

const actions = {};

const OnboardingStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default OnboardingStore;
